import { useContext } from 'react'
import TimelineContext from './Timeline.Context'
import { ITimeline } from './types'

export default function useTimeline() {
  const timeline: ITimeline = useContext(TimelineContext)
  if (timeline && !timeline.started) {
    timeline.start()
  }
  return timeline
}
